var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AuthLayout',{attrs:{"title":"ورود به","button-text":"ورود"},scopedSlots:_vm._u([{key:"fields",fn:function(){return [_c('LoginForm')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }